import { TerritoryMode } from '@pages/Home/context/TerritorySelectionContext';

export const SECTION_ID = 'territory-options';

export const TERRITORY_MODES: TerritoryMode[] = ['state', 'metro'];

export const TERRITORY_MODE_LABELS: Record<TerritoryMode, string> = {
    state: 'State',
    metro: 'Metro',
};
